import ApplicationSerializer from './application';
import config from 'garaje/config/environment';

export default class extends ApplicationSerializer {
  alwaysIncludeLinkageData = false;

  shouldIncludeLinkageData(relationshipKey) {
    // vfdCompanyConfiguration relationship is returned only as a link, not with relationship data
    return relationshipKey !== 'vfdCompanyConfiguration';
  }

  links(company) {
    return {
      vfdCompanyConfiguration: {
        related: `${config.apiHost}/a/visitors/api/v3/company/${company.id}/vfd-company-configuration`,
      },
    };
  }
}
